export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "r-v3/js/GrmMediaStreamTrackGeneratorWorker.runner.25e3f371.worker.js");
}
